import { render, staticRenderFns } from "./TaxDocumentsAllYears.vue?vue&type=template&id=58bcdc18"
import script from "./TaxDocumentsAllYears.vue?vue&type=script&lang=ts"
export * from "./TaxDocumentsAllYears.vue?vue&type=script&lang=ts"
import style0 from "./TaxDocumentsAllYears.vue?vue&type=style&index=0&id=58bcdc18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports